@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/design-tokens/breakpoints/breakpoints' as *;
@use '@design/components/custom-scroll/custom-scroll' as *;

.styledButton {
  svg {
    fill: var(--icon-soft);
  }
}

.styledModal {
  [data-modal-text-container] {
    margin-top: 12px;
    margin-bottom: 0;
  }

  [data-modal-container] {
    background-color: var(--background-soft);
    display: flex;
    flex-direction: column;
    min-height: 460px;
    width: 792px;
    box-shadow: var(--elevation-moderate);
    padding: 0;

    @include respond-to('tablet') {
      width: 95%;
    }

    @include respond-to('mobile') {
      height: 100%;
      width: 100%;
    }
  }

  &[data-modal] {
    top: 0;
  }

  [data-modal-backdrop] {
    background-color: var(--background-backdrop);
    backdrop-filter: blur(1px);
    top: 0;
  }

  [data-modal-header] {
    display: flex;
    align-items: center;
  }

  &.hideHeader [data-modal-header] {
    display: none;
  }

  &.inChartPage {
    &[data-modal] {
      top: var(--app-header-height);
    }

    [data-modal-container] {
      width: 1000px;
    }

    [data-modal-backdrop] {
      background-color: transparent;
      backdrop-filter: blur(0);
      top: var(--app-header-height);
    }
  }

  &.secondaryVariant {
    [data-modal-container] {
      min-height: 520px;
      top: calc(var(--app-header-height) + 12px);
      transform: translateX(-50%);
      background-color: var(--background-soft);
    }
  }
}

.searchResultWrapper {
  flex-shrink: 0;
  width: 600px;
}

.styledDropdown {
  padding: 0;
  overflow-x: hidden;

  [data-dropdown-list] {
    box-shadow: none;
    border: none;
    background-color: unset;
    padding: 0 8px 8px;
    min-height: 300px;
  }

  &.isSecondaryVariant [data-dropdown-list] {
    min-height: 400px;
  }
}

.modalContent {
  display: flex;
  height: 460px;
  width: 1000px;
}

.verticalDivider {
  margin-left: 16px;
  margin-right: 8px;
  border-left: 1px solid var(--border-soft);
  height: 100%;
}

.helpText {
  @include typography-v2-body-sm;

  color: var(--text-soft);
  padding: 12px 16px;
}

.clearButton {
  @include typography-v2-body-sm;

  color: var(--text-soft);
  cursor: pointer;
  border: none;
  background: none;

  &:hover {
    color: var(--text-default);
  }
}

.styledAutocompleteInput {
  [data-input-left-icon] svg {
    fill: var(--text-soft);
  }

  [data-input-container] {
    width: 100%;
  }

  [data-input-wrapper] {
    border: 1px solid var(--border-soft);
    background-color: transparent;
    padding-left: 20px;
  }

  [data-input-element] {
    text-align: left;
  }

  &.autocompleteSecondary [data-input-wrapper] {
    border-left: none;
    border-right: none;
    border-radius: 0;
  }

  &.autocompleteSecondary.autocompleteNoHeader [data-input-wrapper] {
    border-top: none;
    border-radius: 8px 8px 0 0;
  }
}

.panesWrapper {
  @include custom-scroll-minimal;

  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  max-height: 450px;
  overflow-y: scroll;
  width: 361px;
}

.textWrapper {
  padding-left: 8px;
  padding-right: 8px;
}

.helperText {
  @include border-radius-r2;
  @include typography-v2-body-xs;

  border: 1px dashed var(--border-soft);
  display: flex;
  justify-content: center;
  padding: 12px;
  width: 100%;
  color: var(--text-soft);
}

.beforeResultsWrapper {
  &.hasRoundedCorners {
    border-radius: 8px 8px 0 0;
    overflow: hidden;
  }
}

.topBarSearchContainer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: var(--app-header-height);
  z-index: calc(var(--z-index-modal) + 1);
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--background-soft);
  padding: 12px 16px;
  pointer-events: none;
}

.topBarSearchInput {
  pointer-events: auto;
  width: 100%;
  max-width: 600px;

  [data-input-left-icon] svg {
    fill: var(--icon-default);
  }

  [data-input-container] {
    width: 100%;
  }

  [data-input-wrapper] {
    border: 1px solid var(--border-soft);
    border-radius: 40px;
    background-color: var(--surface-default);
    padding-left: 12px;
    padding-right: 18px;
    height: 44px;

    &:focus-within {
      border-color: var(--border-default);
    }
  }

  [data-input-element] {
    @include typography-v2-body-sm;

    text-align: left;
  }
}

.topBarButtonsContainer {
  display: flex;
  align-items: center;
  gap: 8px;
}

.topBarClearButton {
  @include typography-v2-ui-xs;

  color: var(--text-soft);
  cursor: pointer;
  border: none;
  background: none;
  padding: 2px 0;

  &:hover {
    color: var(--text-default);
  }
}

.topBarDivider {
  width: 1px;
  height: 20px;
  background-color: var(--border-soft);
}

.topBarCloseButton {
  cursor: pointer;
  fill: var(--text-soft);

  &:hover {
    fill: var(--text-default);
  }
}
